import styled from "styled-components";

import { SPACING } from "../../../../../utils/constants";

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
`;

export const SkeletonRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: ${SPACING.md}px;
`;
